<template lang='pug'>
.articleStory-bottom
  .articleStory-grid
    .articleStory-itemGrid
      span.articleStory-titleGrid 本篇追蹤人數
      span.articleStory-subtitleGrid2 {{ getNumberString(followerCount) }}
    .articleStory-itemGrid
      span.articleStory-titleGrid 本篇瀏覽人數
      span.articleStory-subtitleGrid {{ getNumberString(info.viewCount) }}
    .articleStory-itemGrid
      span.articleStory-titleGrid 本篇回報人數
      span.articleStory-subtitleGrid {{ getNumberString(info.reporterCount) }}
    .articleStory-itemGrid
      span.articleStory-titleGrid 查核結果
      span.articleStory-subtitleGrid {{ info.tag[$store.state.lang] }}
  .articleStory-rightBottom
    .articleStory-social(v-if="info.tag.id != 1 && identity != 'partners'" )
      .articleStory-itemSocial
        a.articleStory-facebook(:href='"https://www.facebook.com/sharer/sharer.php?u=" + windowLocationHref'
          target="_blank")
      .articleStory-itemSocial
        a.articleStory-line(:href='"https://social-plugins.line.me/lineit/share?url=" + windowLocationHref'
          target="_blank")

    .articleStory-button(v-if='followed' @click="unfollowArticle(info.id)" class="articleStory-button--outlined")
      .articleStory-iconButton.icon-following
      .articleStory-textButton {{ staticData.articlePage.isfollowBtnText }}
    .articleStory-button(v-else @click="followArticle(info.id)" class="articleStory-button--blue")
      .articleStory-textButton {{ staticData.articlePage.unfollowBtnText }}
</template>

<script>
import { login } from "@/plugins/login.js"
import { followArticle } from "@/plugins/api.js"
import { getNumberString } from "@/plugins/tool.js"

export default {
  props: {
    info: Object,
    staticData: Object,
    followStatus: Boolean
  },
  data() {
    return {
      localFollowStatus: null,
      getNumberString: getNumberString,
      token: localStorage.getItem(this.$store.state.storageKeys.token),
      windowLocationHref: "",
      identity: localStorage.getItem(this.$store.state.storageKeys.identity)
    }
  },
  created() {
    this.windowLocationHref = encodeURIComponent(window.location.href)
  },
  computed: {
    followed() {
      return this.localFollowStatus != null ? this.localFollowStatus : this.followStatus
    },
    followerCount() {
      if (this.followStatus == true) {
        if (this.localFollowStatus == false)
          return this.info.followerCount - 1
      }
      else if (this.followStatus == false) {
        if (this.localFollowStatus == true)
          return this.info.followerCount + 1
      }
      return this.info.followerCount
    }
  },
  methods: {
    async followArticle(id) {
      if (this.token == null)
        login(this.$store.state)
      else {
        this.localFollowStatus = !this.followed
        followArticle("follow", this.$store.state, this.$axios, id)
      }
    },
    async unfollowArticle(id) {
      this.localFollowStatus = !this.followed
      followArticle("unfollow", this.$store.state, this.$axios, id)
    }
  }
}
</script>
